import { Component, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ForsidelenkeComponent } from "./forsidelenke/forsidelenke.component";
import { QlikService } from "../felles/services/qlik.service";

@Component({
  selector: "stat-home",
  templateUrl: "./home.component.html",
  imports: [ForsidelenkeComponent],
  providers: [QlikService],
})
export class HomeComponent implements OnInit {
  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    // HOTFIX: setter default filter uten LockedSection for å initialisere felt for senere bruk.
    this.qlikService.setFilter("VirkemiddelKode", "LÅN_HB", false, false);
    this.qlikService.setFilter("TypeTilstand", "Søknad", false, false);
    this.qlikService.setFilter("År", "2020", false, false);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Oversikt - Husbanken");
  }
}
